import {
  CLEAR_EDIT_REFERENCE_EVENT,
  GET_EDIT_REFERENCE_REQUEST,
  CREATE_EDIT_REFERENCE_REQUEST,
  UPDATE_EDIT_REFERENCE_REQUEST,
  GET_EDIT_REFERENCE_HAVE_REQUEST,
  EDIT_REFERENCE_OPEN_CONFIRMATION,
  EDIT_REFERENCE_CANCEL_CONFIRMATION,
} from './referenceEditReducer';

export const getReference = ({ id, history }) => ({ type: GET_EDIT_REFERENCE_REQUEST, id, history });
export const clearReference = () => ({ type: CLEAR_EDIT_REFERENCE_EVENT });
export const createReference = ({
  data, formModel, location, goBack, history,
}) => ({
  type: CREATE_EDIT_REFERENCE_REQUEST, data, formModel, location, goBack, history,
});
export const updateReference = ({
  data, id, formModel, location, goBack, history,
}) => ({
  type: UPDATE_EDIT_REFERENCE_REQUEST, data, id, formModel, location, goBack, history,
});

export const getHaves = ({ history }) => ({ type: GET_EDIT_REFERENCE_HAVE_REQUEST, history });

export const openEditConfirmation = ({ formData }) => ({ type: EDIT_REFERENCE_OPEN_CONFIRMATION, formData });
export const cancelEditConfirmation = () => ({ type: EDIT_REFERENCE_CANCEL_CONFIRMATION });
